import { OnEvent, Service } from '@toeverything/infra';

import { UserQuota } from '../entities/user-quota';
import { AccountChanged } from './auth';

@OnEvent(AccountChanged, e => e._onAccountChanged)
export class UserQuotaService extends Service {
  quota = this.framework.createEntity(UserQuota);

  _onAccountChanged() {
    this.quota.revalidate();
  }
}
